import script from "./SalesReceipt.vue?vue&type=script&setup=true&lang=js"
export * from "./SalesReceipt.vue?vue&type=script&setup=true&lang=js"

import "./SalesReceipt.vue?vue&type=style&index=0&id=3a6c54e8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a6c54e8"]])

export default __exports__